import { render, staticRenderFns } from "./InventoryRecallResolveAction.vue?vue&type=template&id=4fb0b2e4&scoped=true"
import script from "./InventoryRecallResolveAction.vue?vue&type=script&lang=js"
export * from "./InventoryRecallResolveAction.vue?vue&type=script&lang=js"
import "./InventoryRecallResolveAction.vue?vue&type=style&index=0&id=4fb0b2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0b2e4",
  null
  
)

export default component.exports